import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionPlanEmailTemplates } from "./email-templates";
import { InnerHeader } from "./inner-header";

import type { PlanCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	email: PlanCategoriesAndManagerStore["email"];
	name: string;
	hotelID: string;
};

export const QuestionPlanEmail = ({ email, name, hotelID }: Props) => {
	return (
		<div className="flex flex-col gap-y-14">
			<FeatureIslandMainWithCategoryWrapper islandTitle="メール設定" categoryStore={email}>
				<InnerHeader hotelID={hotelID} planName={name} />
			</FeatureIslandMainWithCategoryWrapper>
			<QuestionPlanEmailTemplates email={email} />
		</div>
	);
};

QuestionPlanEmail.displayName = "QuestionPlanEmail";
